export default {
  landing: {
    hero: {
      tag: "Applications open",
      title: "Find your work-study programme",
    },
    error: "Unable to load the page. Check the link you received or try again later.",
    retry: "Retry",
    sections: {
      contact: {
        title: "Your contact details",
        first_name: "First name",
        last_name: "Last name",
        email: "Email address",
        phone: "Phone number",
        last_degree: "Last degree obtained",
        last_school: "Last school attended",
        optional: "(optional)",
        required_indicator: "required field",
        required_error: "This field is required.",
        email_error: "This email address is not valid. Expected format: name@example.com",
      },
      training: {
        title: "Our training courses",
        more_info: "More information",
        modal: {
          close: "Close",
          brochure: "Download the brochure",
          select: "Choose this training course",
          selected: "Training course selected",
        },
      },
      project: {
        preselected_note:
          "You came for “{name}”, already selected below. Other related trainings might also interest you.",
      },
      origin: {
        title: "How did you hear about us?",
      },
      consent: {
        aria_label: "Consent",
        text: "I accept the terms and conditions and the privacy policy. You can unsubscribe at any time.",
        privacy_policy_link: "privacy policy",
        required_error: "Please accept the terms to continue.",
        captcha_label: "Anti-robot check",
      },
    },
    final: {
      info_button: "Receive information",
      apply_button: "Apply",
      rgpd_note: "Your data is processed in accordance with the GDPR.",
      privacy_policy_link: "Privacy policy",
      privacy_policy_title: "Privacy policy",
      info_success: "Thank you! We will send you information very soon.",
      info_sent_title: "Thank you for your interest!",
      info_sent_text:
        "Your request has been sent. The training center's team will send you information about the training you're interested in.",
      info_sent_resume_title: "Want to apply?",
      info_sent_resume_text:
        "We just sent you an email at {email}. It contains a link to resume your application whenever you want, without having to re-enter your details.",
      info_sent_spam_note: "Can't find the email? Remember to check your spam folder.",
      already_registered: "Your file already exists — we will get back to you if needed.",
    },
  },
  // TA-4768/4769: top-level key (not under "landing") - every $t("candidacyGroups...") call in the
  // code (CandidacyGroupsView/CandidacyFormationGroupsComponent/LandingGroupRankBadgeComponent) uses
  // this path without a "landing." prefix.
  candidacyGroups: {
    hero: {
      tag: "Your application",
      title: "Choose a group",
      title_success: "Thank you!",
    },
    intro:
      "You showed interest in one or more of the trainings below. For each one, select the group(s) you wish to apply to and rank them by order of preference.",
    loading: "Loading your trainings…",
    error: "Unable to load your trainings. Check the link you received or try again later.",
    empty: "No training to display.",
    no_groups_title: "No application open yet",
    no_groups_sub: "The CFA will let you know as soon as applications open for this training.",
    entry_year: "Year {year}",
    start_date: "Start: {date}",
    rank: {
      selected: "Choice #{rank}",
      locked: "This group cannot be selected",
    },
    move_up: "Move {name} up in the ranking",
    move_down: "Move {name} down in the ranking",
    max_choices_reached: "You can select a maximum of {max} groups.",
    validate_button: "Submit my application",
    confirm_title: "Submit your application?",
    confirm_text:
      "Your choices will be sent to the CFA and an email will invite you to activate your account. You will still be able to change your ranking afterwards.",
    confirm_button: "Submit",
    success: "Application submitted! You will receive an email to activate your account.",
    success_title: "Your application file has been created",
    success_text:
      "One more step: <strong>confirm your email address</strong>. This check makes sure it's really you and that you'll receive all the information about your application.",
    success_box_title: "Check your emails now",
    success_step1: "Open the email we just sent you.",
    success_step2: "Click the verification link: your applicant portal opens.",
    success_step3: "Complete your file and upload your documents.",
    success_note:
      "Can't find the email? Check your spam folder. Your application will only be reviewed once your file is complete.",
  },
  secureData: {
    hero: {
      tag: "Your data is safe",
      title: "Resume or start over",
    },
    intro:
      "We have kept your request safe. Choose how to continue: pick up where you left off, or enter your details again.",
    resume_title: "Pick up where I left off",
    resume_sub: "Receive a single-use link by email to find your pre-filled form.",
    restart_title: "Enter my details again",
    loading: "Checking your link…",
    error: "Unable to open this page. Check the link you received or try again later.",
    mail_sent: "Email sent! Check your inbox to continue.",
    resume_ok: "Hello {name}, your request is ready to be resumed.",
    resume_continue: "Continue to my application",
    prefill_choice: "Choose how to continue:",
    resume_expired: "This link has expired or was already used. Request a new one below.",
    resend_link: "Receive a new link",
    restart_intro: "Your new details will replace those on your existing application.",
    restart_submit: "Confirm my details",
    restart_error: "Check your details: the email must match your initial request.",
    restart_ok: "Details updated!",
  },
  unsubscribe: {
    hero: {
      tag: "Stop receiving our messages",
      title: "Unsubscribe",
    },
    intro:
      "You can unsubscribe in one click. If you wish, let us know why below — it helps us improve our communications.",
    reasons_label: "Unsubscribe reason",
    error: "Unable to open this page. Check the link you received or try again later.",
    submit: "Confirm my unsubscription",
    submit_error: "Unable to save your unsubscription. Try again later.",
    optional_note: "You can confirm without selecting a reason.",
    done: "Noted, you will no longer receive our communications.",
    reasons: {
      admitted_elsewhere: { title: "Admitted elsewhere", sub: "You found a training course at another institution." },
      not_interested: { title: "No longer interested", sub: "This path no longer matches your plans." },
      not_the_requester: { title: "Not the requester", sub: "You did not initiate this information request." },
      other: { title: "Other", sub: "Another reason than those listed above." },
    },
  },
};
